import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { cloneDeep } from 'lodash-es';

import { API_URL } from '@constants';
import { Room, RoomsCreatePermission, SigningFiles } from '@models';
import { ModalService } from './modal.service';

@Service()
export class RoomService {
  modalService = inject(ModalService);
  http = inject(HttpClient);

  getRooms = (parentRid: number) =>
    this.http.get<Room[]>(`${API_URL}/rooms/${parentRid}/rooms`);

  createRoom = (pathName: string, data: Partial<Room>) =>
    this.http.post<Room>(`${API_URL}/${pathName}/rooms`, data);

  getRoom = (rid: number) => this.http.get<Room>(`${API_URL}/rooms/${rid}`);

  updateRoom = (rid: number, data: Partial<Room>) =>
    this.http.put<Room>(`${API_URL}/rooms/${rid}`, data);

  getRoomConfig = (rid: number) =>
    this.http.get<{ permissions: { levels: unknown[] } }>(
      `${API_URL}/rooms/${rid}/config`
    );

  getRoomsRecursive = (rid: number) =>
    this.http.get<{ subfolders: Room[] }>(
      `${API_URL}/rooms/${rid}/roomsrecursive`
    );

  getRoomsByPath = (pathName: string) =>
    this.http.get<Room[]>(`${API_URL}/${pathName}/rooms`);

  getRoomProperties = () => this.http.get<Room>(`${API_URL}/rooms/properties`);

  getRoomCreatePermission = () =>
    this.http.get<RoomsCreatePermission>(`${API_URL}/rooms/createpermission`);

  getSigningRoom = () => this.http.get<Room>(`${API_URL}/rooms/signingroom`);

  getSigningFiles = (hideDuplicates: boolean = true) =>
    this.http.get<SigningFiles>(
      `${API_URL}/rooms/signing?hideDuplicates=${hideDuplicates}`
    );

  editRoom = async (room: Room, rid: number) => {
    const { EditRoomModalComponent } =
      await import('../../modules/rooms/components/edit-room-modal.component');

    return this.modalService.open(
      EditRoomModalComponent,
      {
        room: cloneDeep(room),
        rid,
      },
      {
        modalDialogClass: 'lg-modal',
      }
    );
  };
}
